__turbopack_context__.v({
  "clearButton": "styles-module-scss-module__qNQ_9G__clearButton",
  "dragging": "styles-module-scss-module__qNQ_9G__dragging",
  "dropInner": "styles-module-scss-module__qNQ_9G__dropInner",
  "dropdown": "styles-module-scss-module__qNQ_9G__dropdown",
  "exitButton": "styles-module-scss-module__qNQ_9G__exitButton",
  "fadeIn": "styles-module-scss-module__qNQ_9G__fadeIn",
  "goButton": "styles-module-scss-module__qNQ_9G__goButton",
  "goButtonHighlight": "styles-module-scss-module__qNQ_9G__goButtonHighlight",
  "imageDropZone": "styles-module-scss-module__qNQ_9G__imageDropZone",
  "imageSearchButton": "styles-module-scss-module__qNQ_9G__imageSearchButton",
  "imageSearchOverlay": "styles-module-scss-module__qNQ_9G__imageSearchOverlay",
  "input": "styles-module-scss-module__qNQ_9G__input",
  "inputContainer": "styles-module-scss-module__qNQ_9G__inputContainer",
  "inputOverlay": "styles-module-scss-module__qNQ_9G__inputOverlay",
  "label": "styles-module-scss-module__qNQ_9G__label",
  "linkInputField": "styles-module-scss-module__qNQ_9G__linkInputField",
  "pulseArrow": "styles-module-scss-module__qNQ_9G__pulseArrow",
  "searchInput": "styles-module-scss-module__qNQ_9G__searchInput",
  "suggestionItem": "styles-module-scss-module__qNQ_9G__suggestionItem",
  "suggestionLabel": "styles-module-scss-module__qNQ_9G__suggestionLabel",
  "suggestionList": "styles-module-scss-module__qNQ_9G__suggestionList",
  "suggestionType": "styles-module-scss-module__qNQ_9G__suggestionType",
  "textRefineInput": "styles-module-scss-module__qNQ_9G__textRefineInput",
  "title": "styles-module-scss-module__qNQ_9G__title",
  "typewriterOverlay": "styles-module-scss-module__qNQ_9G__typewriterOverlay",
  "uploadLink": "styles-module-scss-module__qNQ_9G__uploadLink",
});
